export { default } from './RoutineExamsModule';
